import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutletComponent } from '@shared/ui/components';

@Component({
  selector: 'reza-protected',
  standalone: true,
  imports: [CommonModule, RouterOutletComponent],
  templateUrl: './Protected.component.html',
  styleUrl: './Protected.component.css',
})
export class ProtectedComponent {}
